import type {
  EmbeddedNavigationGroup,
  EmbeddedNavigationItem,
} from '@/types/embeddedApplication';

// Returns the label trail from the item's containing group (if named) down through
// its selected descendants, so nested/grouped menu items show their full hierarchy.
export function findSelectedItemPath(
  groups: EmbeddedNavigationGroup[],
  selectedMenuId: string,
): string[] {
  const search = (items: EmbeddedNavigationItem[]): string[] | null => {
    for (const item of items) {
      if (item.id === selectedMenuId) {
        return [item.label];
      }

      const childPath = item.children?.length ? search(item.children) : null;

      if (childPath) {
        return [item.label, ...childPath];
      }
    }

    return null;
  };

  for (const group of groups) {
    const path = search(group.items);

    if (path) {
      return group.label ? [group.label, ...path] : path;
    }
  }

  return [];
}
